<template>

    <section class="c-settings_offices">
        <h3>Zarządzanie placówkami</h3>
        <form-desc>
            Możesz dodać placówkę ręcznie, bądź
            <a @click.prevent="syncOffices" class="c-settings_offices__link">pobrać swoje placówki z portalu</a>
        </form-desc>
        <form-input
            label="Dodaj placówkę"
            v-model="newOffice"
            @click="storeOffice"
            speech-to-text
            btn="green"
            btn-label="Dodaj"
            btn-has-loader
            :btn-loading="isLoading">
        </form-input>
        <v-table class="c-settings_offices__table" v-if="phtOffices && phtOffices.length">
            <thead>
            <th>Nazwa</th>
            <th>Akcje</th>
            </thead>
            <tbody>
            <tr v-for="office in phtOffices" :key="office.id">
                <td>{{ office.name }}</td>
                <td class="c-settings_offices__table-actions">
                    <v-btn
                        type="icon"
                        icon="edit"
                        title="Edytuj pacjenta"
                        @click="$refs.settingsOfficeEditModal.$emit('open', office)">
                    </v-btn>
                    <v-btn
                        type="icon"
                        icon="delete"
                        title="Usuń pacjenta"
                        @click="deleteOffice(office.id)">
                    </v-btn>
                </td>
            </tr>
            </tbody>
        </v-table>
        <p class="c-settings_offices__empty" v-else>Brak placówek</p>
        <settings-ext-office-modal ref="settingsExtOfficeModal"></settings-ext-office-modal>
        <settings-office-edit-modal ref="settingsOfficeEditModal" @ok="updateOffice"></settings-office-edit-modal>
    </section>

</template>


<script>

import SettingsExtOfficeModal from 'Components/Settings/SettingsExtOfficeModal'
import SettingsOfficeEditModal from 'Components/Settings/SettingsOfficeEditModal'

import {mapGetters} from 'vuex'
import {FormRow, FormInput, FormDesc} from 'Components/Form'
import VBtn from 'Components/VBtn'
import VTable from 'Components/VTable'

export default {

    name: 'SettingsOffices',

    data() {
        return {
            isLoading: false,
            newOffice: ''
        }
    },

    computed: {
        ...mapGetters(['phtOffices'])
    },

    methods: {
        storeOffice() {
            this.isLoading = true
            this.$store.dispatch('PHT_OFFICE_STORE', this.newOffice).then(() => {
                this.newOffice = ''
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
            })
        },
        updateOffice(office, closeModal) {
            this.isLoading = true
            this.$store.dispatch('PHT_OFFICE_UPDATE', office).then(() => {
                this.isLoading = false
                closeModal()
            }).catch(() => {
                this.isLoading = false
            })
        },
        deleteOffice(officeId) {
            this.$store.dispatch('PHT_OFFICE_REMOVE', officeId).catch((error) => {
                this.$alert.error('Zarządzanie placówkami', error.response.data.message)
            })
        },
        syncOffices() {
            this.$refs.settingsExtOfficeModal.$emit('open')
        }
    },

    components: {
        SettingsExtOfficeModal,
        SettingsOfficeEditModal,
        FormRow,
        FormInput,
        FormDesc,
        VBtn,
        VTable
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-settings_offices {
    &__link {
        white-space: nowrap;
    }
    &__table {
        margin-top: 2rem;

        &-actions {
            display: flex;
            width: 100%;
            justify-content: flex-end;
            flex-shrink: 0;

            span {
                margin-right: .5rem;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1.2rem;
        margin-top: 2.5rem;
        margin-bottom: 0;
        width: 100%;
        text-align: center;
    }
}

</style>
